import xhr from 'xhr'

export default async function getInfoStudentAdviser(data) {
  if (data.id_est) {
    const dataStudent = await xhr(`/students/${data.id_est}?populate=deep,3`)
    const resProgramTypes = await xhr(`/program-types/student/${data.id_est}`)
    const resParent = await xhr(
      `/parents?filters[students][id][$in]=${data.id_est}&populate=*`
    )
    const affiliate = await xhr(
      `/affiliate-records?filters[student][id][$eq]=${data.id_est}&populate=deep,3`
    )

    return {
      programTypes: resProgramTypes.data,
      estudiante: dataStudent.data.data,
      parent: resParent.data.data[0] || null,
      affiliate: affiliate.data.data[0]?.affiliate,
    }
  }
}
